import { SeriesFunction } from '../../';

const _ = require('lodash');

export const growth = new SeriesFunction(
  ({anchorIndex = 0, constantGrowth = 0.0, exponentialGrowth = 0.0, series = null}) => {
    let newValues = [];
    let dates = series.getIndices();
    let values = series.getValues();

    let lastNonNullIndex = _.findLastIndex(values, v => v !== null);
    
    for (let t=0; t < values.length; t++) {
      let baseT = (t <= lastNonNullIndex) ? t : lastNonNullIndex;

      let tValue = values[baseT]
        + values[baseT] * ((1 + exponentialGrowth/100) ** (t - anchorIndex) - 1)
        + constantGrowth * (t - anchorIndex);
      
      newValues.push(tValue);
    }

    let newData = _.zip(dates, newValues);

    return new series.constructor(newData);
  },
  {
    label: 'Adjust the Series with Growth',
    parameters: [
      {'name': 'series', 'type': 'series'},
      {'name': 'anchorIndex', 'type': 'number', 'default': 0},
      {'name': 'constantGrowth', 'type': 'number', 'default': 0},
      {'name': 'exponentialGrowth', 'type': 'number', 'default': 0}
    ],
    maxInputSize: 1
  }
);